define([
    'commercial/modules/dfp/dfp-env'
], function (dfpEnv) {
    return getAdvertById;

    function getAdvertById(id) {
        return id in dfpEnv.advertIds ? dfpEnv.adverts[dfpEnv.advertIds[id]] : null;
    }
});



//////////////////
// WEBPACK FOOTER
// ./static/src/javascripts-legacy/projects/commercial/modules/dfp/get-advert-by-id.js
// module id = 242
// module chunks = 0 1 15